module.exports = __webpack_public_path__ + "static/media/OCP.163ae15d.png";